export abstract class LocalStorageKeys {
  static readonly Token: string = "token";
  static readonly Menu: string = "menu";
  static readonly Usuario: string = "usuario";
  static readonly TenantId: string = "tenantId";
  static readonly ConsorcioId: string = "consorcioId";
  static readonly NamesToReplace: string = "namesToReplace";
  static readonly ReturnUrl: string = "returnUrl";
  static readonly ComunidadId: string = "comunidadId";
}

export abstract class SignalRConstants {
  static readonly RetriesArray: [2000, 10000, 30000, 60000];
}

export abstract class ExportMediaTypeConstants {
  static readonly Csv: number = 1;
  static readonly Excel: number = 2;
}

export abstract class GridPageSettings {
  static readonly PageSizeList: number[] = [5, 10, 15];
  static readonly PageCount: number = 10;
}

export abstract class ProveedorEnvioMailConstants {
  static readonly SMTP: number = 1;
  static readonly MAIL_KIT: number = 2;
  static readonly GOOGLE_WORKSPACE: number = 3;
}

export abstract class TenantFeatureFlagEnum {
  static readonly GestionConsorcio: number = 1;
  static readonly GestionObra: number = 2;
  static readonly GestionUf: number = 3;
  static readonly ControlGastos: number = 4;
  static readonly ControlExpensas: number = 5;
  static readonly ControlPedidos: number = 6;
  static readonly ControlCaja: number = 7;
  static readonly Facturacion: number = 8;
  static readonly LiquidacionSueldos: number = 9;
  static readonly ControlContratos: number = 10;
}

export abstract class MovimientoSaldoPagoModoConstants {
  static readonly IngresoManual: number = 1;
  static readonly SaldarTodo: number = 2;
}

export abstract class EstadoConstants {
  static readonly ESTADO_USUARIO_PENDIENTE: number = 1;
  static readonly ESTADO_USUARIO_APROBADO: number = 2;
  static readonly ESTADO_USUARIO_RECHAZADO: number = 3;

  static readonly ESTADO_INCIDENCIA_PEND_REV: number = 4;
  static readonly ESTADO_INCIDENCIA_EN_REVISION: number = 5;
  static readonly ESTADO_INCIDENCIA_CERRADA: number = 6;

  static readonly ESTADO_PEDIDO_CREADO: number = 7;
  static readonly ESTADO_PEDIDO_PENDIENTE_REVISION: number = 8;
  static readonly ESTADO_PEDIDO_PENDIENTE_PRESUPUESTO: number = 9;
  static readonly ESTADO_PEDIDO_RECHAZADO: number = 10;
  static readonly ESTADO_PEDIDO_PENDIENTE_COORDINACION: number = 11;
  static readonly ESTADO_PEDIDO_PENDIENTE_ENTREGA: number = 12;
  static readonly ESTADO_PEDIDO_ENTREGADO: number = 13;
  static readonly ESTADO_PEDIDO_FINALIZADO: number = 14;

  static readonly ESTADO_MOVIMIENTO_PENDIENTE: number = 15;
  static readonly ESTADO_MOVIMIENTO_CONFIRMADO: number = 16;
  static readonly ESTADO_MOVIMIENTO_CANCELADO: number = 17;

  static readonly ESTADO_EXPENSA_BORRADOR: number = 18;
  static readonly ESTADO_EXPENSA_PUBLICADA: number = 19;
}

export abstract class ReporteConsolidadoCajaAgrupadorConstants {
  static readonly Tenant: number = 1;
  static readonly Comunidad: number = 2;
  static readonly Proveedor: number = 3;
  static readonly Consorcio: number = 4;
  static readonly UnidadFuncional: number = 5;
  static readonly Persona: number = 6;
}

export abstract class MensajeUsuarioOpcionEnvioConstants {
  static readonly ROL: number = 1;
  static readonly USUARIO: number = 2;
  static readonly TODOS: number = 3;
  static readonly ADMINISTRACION: number = 4;
  static readonly COMUNIDAD: number = 5;
}

export abstract class RolTipoConstants {
  static readonly SUPER_ADMIN: number = 1;
  static readonly ADMIN: number = 2;
  static readonly BACKOFFICE: number = 3;
  static readonly GESTOR: number = 4;
  static readonly USUARIO: number = 5;
}

export abstract class PedidoComunidadRolConstants {
  static readonly EMPLEADO: number = 1;
  static readonly JEFE_DE_OBRA: number = 2;
  static readonly COORDINADOR: number = 3;
  static readonly COORDINADOR_GENERAL: number = 4;
  static readonly CEO: number = 5;
}

export abstract class MedioPagoConstants {
  static readonly Efectivo: number = 1;
  static readonly Transferencia: number = 2;
  static readonly Cheque: number = 3;
  static readonly CreditoEnCuenta: number = 4;
}

export abstract class ContratoTipoConstants {
  static readonly Alquiler: number = 1;
  static readonly Venta: number = 2;
  static readonly Alquiler_Mall: number = 3;
}

export abstract class ConceptosRecargoConstants {
  static readonly TotalExpensa: number = 1;
  static readonly GastosSeleccionados: number = 2;
}

export abstract class MenuFuncionCodes {
  static readonly HOME: string = "HOME";
  static readonly ADMIN: string = "ADMIN";
  static readonly PROC: string = "PROC";

  static readonly USER: string = "USER";
  static readonly USER_LIST: string = "USER_LIST";
  static readonly USER_EDIT: string = "USER_EDIT";
  static readonly USER_ADD: string = "USER_ADD";
  static readonly USER_DELETE: string = "USER_DELETE";
  static readonly USER_ACTIONS: string = "USER_ACTIONS";

  static readonly ROL: string = "ROL";
  static readonly ROL_LIST: string = "ROL_LIST";
  static readonly ROL_EDIT: string = "ROL_EDIT";
  static readonly ROL_ADD: string = "ROL_ADD";
  static readonly ROL_DELETE: string = "ROL_DELETE";

  static readonly ESTADO: string = "ESTADO";
  static readonly ESTADO_LIST: string = "ESTADO_LIST";
  static readonly ESTADO_EDIT: string = "ESTADO_EDIT";
  static readonly ESTADO_ADD: string = "ESTADO_ADD";
  static readonly ESTADO_DELETE: string = "ESTADO_DELETE";

  static readonly MENU: string = "MENU";
  static readonly MENU_LIST: string = "MENU_LIST";
  static readonly MENU_EDIT: string = "MENU_EDIT";
  static readonly MENU_ADD: string = "MENU_ADD";
  static readonly MENU_DELETE: string = "MENU_DELETE";

  static readonly PARAM_SISTEMA: string = "PARAM_SISTEMA";
  static readonly PARAM_SISTEMA_LIST: string = "PARAM_SISTEMA_LIST";
  static readonly PARAM_SISTEMA_EDIT: string = "PARAM_SISTEMA_EDIT";
  static readonly PARAM_SISTEMA_ADD: string = "PARAM_SISTEMA_ADD";
  static readonly PARAM_SISTEMA_DELETE: string = "PARAM_SISTEMA_DELETE";

  static readonly MENSAJE_USUARIO_LIST: string = "MENSAJE_USUARIO_LIST";
  static readonly MENSAJE_USUARIO_EDIT: string = "MENSAJE_USUARIO_EDIT";

  static readonly MENSAJE_USUARIO_TIPO: string = "MENSAJE_USUARIO_TIPO";
  static readonly MENSAJE_USUARIO_TIPO_LIST: string = "MENSAJE_USUARIO_TIPO_LIST";
  static readonly MENSAJE_USUARIO_TIPO_EDIT: string = "MENSAJE_USUARIO_TIPO_EDIT";
  static readonly MENSAJE_USUARIO_TIPO_ADD: string = "MENSAJE_USUARIO_TIPO_ADD";
  static readonly MENSAJE_USUARIO_TIPO_DELETE: string = "MENSAJE_USUARIO_TIPO_DELETE";

  static readonly MENSAJE_USUARIO_OPC_ENVIO: string = "MENSAJE_USUARIO_OPC_ENVIO";
  static readonly MENSAJE_USUARIO_OPC_ENVIO_LIST: string = "MENSAJE_USUARIO_OPC_ENVIO_LIST";
  static readonly MENSAJE_USUARIO_OPC_ENVIO_EDIT: string = "MENSAJE_USUARIO_OPC_ENVIO_EDIT";
  static readonly MENSAJE_USUARIO_OPC_ENVIO_ADD: string = "MENSAJE_USUARIO_OPC_ENVIO_ADD";
  static readonly MENSAJE_USUARIO_OPC_ENVIO_DELETE: string = "MENSAJE_USUARIO_OPC_ENVIO_DELETE";

  static readonly MAIL_CONFIGURACION: string = "MAIL_CONFIGURACION";
  static readonly MAIL_CONFIGURACION_LIST: string = "MAIL_CONFIGURACION_LIST";
  static readonly MAIL_CONFIGURACION_EDIT: string = "MAIL_CONFIGURACION_EDIT";
  static readonly MAIL_CONFIGURACION_ADD: string = "MAIL_CONFIGURACION_ADD";
  static readonly MAIL_CONFIGURACION_DELETE: string = "MAIL_CONFIGURACION_DELETE";

  static readonly TENANT: string = "TENANT";
  static readonly TENANT_LIST: string = "TENANT_LIST";
  static readonly TENANT_ADD: string = "TENANT_ADD";
  static readonly TENANT_EDIT: string = "TENANT_EDIT";
  static readonly TENANT_DELETE: string = "TENANT_DELETE";
  static readonly TENANT_ADMIN: string = "TENANT_ADMIN";

  static readonly ROL_TIPO: string = "ROL_TIPO";
  static readonly ROL_TIPO_LIST: string = "ROL_TIPO_LIST";
  static readonly ROL_TIPO_EDIT: string = "ROL_TIPO_EDIT";
  static readonly ROL_TIPO_ADD: string = "ROL_TIPO_ADD";
  static readonly ROL_TIPO_DELETE: string = "ROL_TIPO_DELETE";

  static readonly FAQ: string = "FAQ";
  static readonly FAQ_LIST: string = "FAQ_LIST";
  static readonly FAQ_EDIT: string = "FAQ_EDIT"; 
  static readonly FAQ_ADD: string = "FAQ_ADD"; 
  static readonly FAQ_DELETE: string = "FAQ_DELETE"; 

  static readonly CATEGORIA_SUTERH: string = "CATEGORIA_SUTERH";
  static readonly CATEGORIA_SUTERH_LIST: string = "CATEGORIA_SUTERH_LIST";
  static readonly CATEGORIA_SUTERH_EDIT: string = "CATEGORIA_SUTERH_EDIT";
  static readonly CATEGORIA_SUTERH_ADD: string = "CATEGORIA_SUTERH_ADD";
  static readonly CATEGORIA_SUTERH_DELETE: string = "CATEGORIA_SUTERH_DELETE";

  static readonly COMUNIDAD: string = "COMUNIDAD";
  static readonly COMUNIDAD_LIST: string = "COMUNIDAD_LIST";
  static readonly COMUNIDAD_EDIT: string = "COMUNIDAD_EDIT";
  static readonly COMUNIDAD_ADD: string = "COMUNIDAD_ADD";
  static readonly COMUNIDAD_DELETE: string = "COMUNIDAD_DELETE";

  static readonly COMUNIDAD_PUBLICACIONES: string = "COMUNIDAD_PUBLICACIONES";
  static readonly COMUNIDAD_PUBLICACIONES_LIST: string = "COMUNIDAD_PUBLICACIONES_LIST";
  static readonly COMUNIDAD_PUBLICACIONES_EDIT: string = "COMUNIDAD_PUBLICACIONES_EDIT";
  static readonly COMUNIDAD_PUBLICACIONES_ADD: string = "COMUNIDAD_PUBLICACIONES_ADD";
  static readonly COMUNIDAD_PUBLICACIONES_DELETE: string = "COMUNIDAD_PUBLICACIONES_DELETE";

  static readonly TIPO_COMUNIDAD: string = "TIPO_COMUNIDAD";
  static readonly TIPO_COMUNIDAD_LIST: string = "TIPO_COMUNIDAD_LIST";
  static readonly TIPO_COMUNIDAD_EDIT: string = "TIPO_COMUNIDAD_EDIT";
  static readonly TIPO_COMUNIDAD_ADD: string = "TIPO_COMUNIDAD_ADD";
  static readonly TIPO_COMUNIDAD_DELETE: string = "TIPO_COMUNIDAD_DELETE";

  static readonly CONSORCIO: string = "CONSORCIO";
  static readonly CONSORCIO_LIST: string = "CONSORCIO_LIST";
  static readonly CONSORCIO_EDIT: string = "CONSORCIO_EDIT";
  static readonly CONSORCIO_ADD: string = "CONSORCIO_ADD";
  static readonly CONSORCIO_DELETE: string = "CONSORCIO_DELETE";

  static readonly MONEDA: string = "MONEDA";
  static readonly MONEDA_LIST: string = "MONEDA_LIST";
  static readonly MONEDA_EDIT: string = "MONEDA_EDIT";
  static readonly MONEDA_ADD: string = "MONEDA_ADD";
  static readonly MONEDA_DELETE: string = "MONEDA_DELETE";

  static readonly MONEDA_CONVERSION: string = "MONEDA_CONVERSION";
  static readonly MONEDA_CONVERSION_LIST: string = "MONEDA_CONVERSION_LIST";
  static readonly MONEDA_CONVERSION_EDIT: string = "MONEDA_CONVERSION_EDIT";
  static readonly MONEDA_CONVERSION_ADD: string = "MONEDA_CONVERSION_ADD";
  static readonly MONEDA_CONVERSION_DELETE: string = "MONEDA_CONVERSION_DELETE";

  static readonly PAIS: string = "PAIS";
  static readonly PAIS_LIST: string = "PAIS_LIST";
  static readonly PAIS_EDIT: string = "PAIS_EDIT";
  static readonly PAIS_ADD: string = "PAIS_ADD";
  static readonly PAIS_DELETE: string = "PAIS_DELETE";

  static readonly PERSONA: string = "PERSONA";
  static readonly PERSONA_LIST: string = "PERSONA_LIST";
  static readonly PERSONA_EDIT: string = "PERSONA_EDIT";
  static readonly PERSONA_ADD: string = "PERSONA_ADD";
  static readonly PERSONA_DELETE: string = "PERSONA_DELETE";

  static readonly PROVINCIA: string = "PROVINCIA";
  static readonly PROVINCIA_LIST: string = "PROVINCIA_LIST";
  static readonly PROVINCIA_EDIT: string = "PROVINCIA_EDIT";
  static readonly PROVINCIA_ADD: string = "PROVINCIA_ADD";
  static readonly PROVINCIA_DELETE: string = "PROVINCIA_DELETE";

  static readonly TIPO_DOCUMENTO: string = "TIPO_DOCUMENTO";
  static readonly TIPO_DOCUMENTO_LIST: string = "TIPO_DOCUMENTO_LIST";
  static readonly TIPO_DOCUMENTO_EDIT: string = "TIPO_DOCUMENTO_EDIT";
  static readonly TIPO_DOCUMENTO_ADD: string = "TIPO_DOCUMENTO_ADD";
  static readonly TIPO_DOCUMENTO_DELETE: string = "TIPO_DOCUMENTO_DELETE";

  static readonly TIPO_RESPONSABLE_IVA: string = "TIPO_RESPONSABLE_IVA";
  static readonly TIPO_RESPONSABLE_IVA_LIST: string = "TIPO_RESPONSABLE_IVA_LIST";
  static readonly TIPO_RESPONSABLE_IVA_EDIT: string = "TIPO_RESPONSABLE_IVA_EDIT";
  static readonly TIPO_RESPONSABLE_IVA_ADD: string = "TIPO_RESPONSABLE_IVA_ADD";
  static readonly TIPO_RESPONSABLE_IVA_DELETE: string = "TIPO_RESPONSABLE_IVA_DELETE";

  static readonly TIPO_UNIDAD: string = "TIPO_UNIDAD";
  static readonly TIPO_UNIDAD_LIST: string = "TIPO_UNIDAD_LIST";
  static readonly TIPO_UNIDAD_EDIT: string = "TIPO_UNIDAD_EDIT";
  static readonly TIPO_UNIDAD_ADD: string = "TIPO_UNIDAD_ADD";
  static readonly TIPO_UNIDAD_DELETE: string = "TIPO_UNIDAD_DELETE";

  static readonly UF_TIPO_RELACION: string = "UF_TIPO_RELACION";
  static readonly UF_TIPO_RELACION_LIST: string = "UF_TIPO_RELACION_LIST";
  static readonly UF_TIPO_RELACION_EDIT: string = "UF_TIPO_RELACION_EDIT";
  static readonly UF_TIPO_RELACION_ADD: string = "UF_TIPO_RELACION_ADD";
  static readonly UF_TIPO_RELACION_DELETE: string = "UF_TIPO_RELACION_DELETE";
  
  static readonly UNIDAD_FUNCIONAL: string = "UNIDAD_FUNCIONAL";
  static readonly UNIDAD_FUNCIONAL_LIST: string = "UNIDAD_FUNCIONAL_LIST";
  static readonly UNIDAD_FUNCIONAL_ADD: string = "UNIDAD_FUNCIONAL_ADD";
  static readonly UNIDAD_FUNCIONAL_EDIT: string = "UNIDAD_FUNCIONAL_EDIT";
  static readonly UNIDAD_FUNCIONAL_DELETE: string = "UNIDAD_FUNCIONAL_DELETE";
  static readonly UNIDAD_FUNCIONAL_PERSONA: string = "UNIDAD_FUNCIONAL_PERSONA";
  
  static readonly EXPENSA: string = "EXPENSA";
  static readonly EXPENSA_CONFIG: string = "EXPENSA_CONFIG";
  static readonly EXPENSA_PROCESO: string = "EXPENSA_PROCESO";
  static readonly EXPENSA_LIQUIDACION: string = "EXPENSA_LIQUIDACION";
  static readonly EXPENSA_LIST: string = "EXPENSA_LIST";
  static readonly EXPENSA_EDIT: string = "EXPENSA_EDIT";
  static readonly EXPENSA_DELETE: string = "EXPENSA_DELETE";
  
  static readonly GASTO: string = "GASTO";
  static readonly GASTO_LIST: string = "GASTO_LIST";
  static readonly MI_GASTO_LIST: string = "MI_GASTO_LIST";
  static readonly GASTO_ADD: string = "GASTO_ADD";
  static readonly GASTO_EDIT: string = "GASTO_EDIT";
  static readonly GASTO_DELETE: string = "GASTO_DELETE";
  static readonly GASTO_ASOCIAR_COMUNIDAD: string = "GASTO_ASOCIAR_COMUNIDAD";
  static readonly GASTO_ASOCIAR_UF: string = "GASTO_ASOCIAR_UF";
  static readonly GASTO_ANALISIS_DOCUMENTO: string = "GASTO_ANALISIS_DOCUMENTO";
  static readonly GASTO_ANALISIS_DOCUMENTO_MASIVO: string = "GASTO_ANALISIS_DOCUMENTO_MASIVO";
  static readonly GASTO_RECURRENTES: string = "GASTO_RECURRENTES";

  static readonly SERVICIO_GASTO: string = "SERVICIO_GASTO";
  static readonly SERVICIO_GASTO_LIST: string = "SERVICIO_GASTO_LIST";
  static readonly SERVICIO_GASTO_EDIT: string = "SERVICIO_GASTO_EDIT";
  static readonly SERVICIO_GASTO_ADD: string = "SERVICIO_GASTO_ADD";
  static readonly SERVICIO_GASTO_DELETE: string = "SERVICIO_GASTO_DELETE";

  static readonly CATEGORIA_GASTO: string = "CATEGORIA_GASTO";
  static readonly CATEGORIA_GASTO_LIST: string = "CATEGORIA_GASTO_LIST";
  static readonly CATEGORIA_GASTO_EDIT: string = "CATEGORIA_GASTO_EDIT";
  static readonly CATEGORIA_GASTO_ADD: string = "CATEGORIA_GASTO_ADD";
  static readonly CATEGORIA_GASTO_DELETE: string = "CATEGORIA_GASTO_DELETE";

  static readonly TIPO_GASTO: string = "TIPO_GASTO";
  static readonly TIPO_GASTO_LIST: string = "TIPO_GASTO_LIST";
  static readonly TIPO_GASTO_EDIT: string = "TIPO_GASTO_EDIT";
  static readonly TIPO_GASTO_ADD: string = "TIPO_GASTO_ADD";
  static readonly TIPO_GASTO_DELETE: string = "TIPO_GASTO_DELETE";

  static readonly SERVICIO_GRUPO: string = "SERVICIO_GRUPO";
  static readonly SERVICIO_GRUPO_LIST: string = "SERVICIO_GRUPO_LIST";
  static readonly SERVICIO_GRUPO_EDIT: string = "SERVICIO_GRUPO_EDIT";
  static readonly SERVICIO_GRUPO_ADD: string = "SERVICIO_GRUPO_ADD";
  static readonly SERVICIO_GRUPO_DELETE: string = "SERVICIO_GRUPO_DELETE";

  static readonly CUENTA: string = "CUENTA";
  static readonly CUENTA_LIST: string = "CUENTA_LIST";
  static readonly CUENTA_EDIT: string = "CUENTA_EDIT";
  static readonly CUENTA_ADD: string = "CUENTA_ADD";
  static readonly CUENTA_DELETE: string = "CUENTA_DELETE";
  
  static readonly CONTRATO: string = "CONTRATO";
  static readonly CONTRATO_LIST: string = "CONTRATO_LIST";
  static readonly CONTRATO_ADD: string = "CONTRATO_ADD";
  static readonly CONTRATO_EDIT: string = "CONTRATO_EDIT";
  static readonly CONTRATO_DELETE: string = "CONTRATO_DELETE";

  static readonly INCIDENCIA_USUARIO: string = "INCIDENCIA_USUARIO";
  static readonly INCIDENCIA_USUARIO_LIST: string = "INCIDENCIA_USUARIO_LIST";
  static readonly INCIDENCIA_USUARIO_EDIT: string = "INCIDENCIA_USUARIO_EDIT";
  static readonly INCIDENCIA_USUARIO_LIST_BO: string = "INCIDENCIA_USUARIO_LIST_BO";
  static readonly INCIDENCIA_USUARIO_EDIT_BO: string = "INCIDENCIA_USUARIO_EDIT_BO";
  static readonly INCIDENCIA_USUARIO_ASOCIAR_PERSONA: string = "INCIDENCIA_USUARIO_ASOCIAR_PERSONA";
  static readonly INCIDENCIA_USUARIO_ASOCIAR_PROVEEDOR: string = "INCIDENCIA_USUARIO_ASOCIAR_PROVEEDOR";
  static readonly INCIDENCIA_USUARIO_ASOCIAR_PEDIDO: string = "INCIDENCIA_USUARIO_ASOCIAR_PEDIDO";
  static readonly INCIDENCIA_USUARIO_ASOCIAR_COMUNIDAD: string = "INCIDENCIA_USUARIO_ASOCIAR_COMUNIDAD";
  static readonly INCIDENCIA_USUARIO_ASOCIAR_CONTRATO: string = "INCIDENCIA_USUARIO_ASOCIAR_CONTRATO";
  static readonly INCIDENCIA_USUARIO_ASOCIAR_UF: string = "INCIDENCIA_USUARIO_ASOCIAR_UF";

  static readonly INCIDENCIA_USUARIO_CATEGORIA: string = "INCIDENCIA_USUARIO_CATEGORIA";
  static readonly INCIDENCIA_USUARIO_CATEGORIA_LIST: string = "INCIDENCIA_USUARIO_CATEGORIA_LIST";
  static readonly INCIDENCIA_USUARIO_CATEGORIA_EDIT: string = "INCIDENCIA_USUARIO_CATEGORIA_EDIT";
  static readonly INCIDENCIA_USUARIO_CATEGORIA_ADD: string = "INCIDENCIA_USUARIO_CATEGORIA_ADD";
  static readonly INCIDENCIA_USUARIO_CATEGORIA_DELETE: string = "INCIDENCIA_USUARIO_CATEGORIA_DELETE";

  static readonly MATERIAL: string = "MATERIAL";
  static readonly MATERIAL_LIST: string = "MATERIAL_LIST";
  static readonly MATERIAL_EDIT: string = "MATERIAL_EDIT";
  static readonly MATERIAL_ADD: string = "MATERIAL_ADD";
  static readonly MATERIAL_DELETE: string = "MATERIAL_DELETE";

  static readonly TIPO_MATERIAL: string = "TIPO_MATERIAL";
  static readonly TIPO_MATERIAL_LIST: string = "TIPO_MATERIAL_LIST";
  static readonly TIPO_MATERIAL_EDIT: string = "TIPO_MATERIAL_EDIT";
  static readonly TIPO_MATERIAL_ADD: string = "TIPO_MATERIAL_ADD";
  static readonly TIPO_MATERIAL_DELETE: string = "TIPO_MATERIAL_DELETE";

  static readonly UNIDAD_MEDIDA_MATERIAL: string = "UNIDAD_MEDIDA_MATERIAL";
  static readonly UNIDAD_MEDIDA_MATERIAL_LIST: string = "UNIDAD_MEDIDA_MATERIAL_LIST";
  static readonly UNIDAD_MEDIDA_MATERIAL_EDIT: string = "UNIDAD_MEDIDA_MATERIAL_EDIT";
  static readonly UNIDAD_MEDIDA_MATERIAL_ADD: string = "UNIDAD_MEDIDA_MATERIAL_ADD";
  static readonly UNIDAD_MEDIDA_MATERIAL_DELETE: string = "UNIDAD_MEDIDA_MATERIAL_DELETE";

  static readonly EMPLEADO_ASISTENCIA: string = "EMPLEADO_ASISTENCIA";
  static readonly EMPLEADO_ASISTENCIA_LIST: string = "EMPLEADO_ASISTENCIA_LIST";
  static readonly EMPLEADO_ASISTENCIA_EDIT: string = "EMPLEADO_ASISTENCIA_EDIT";
  static readonly EMPLEADO_ASISTENCIA_ADD: string = "EMPLEADO_ASISTENCIA_ADD";
  static readonly EMPLEADO_ASISTENCIA_DELETE: string = "EMPLEADO_ASISTENCIA_DELETE";

  static readonly EMPLEADO: string = "EMPLEADO";
  static readonly EMPLEADO_LIST: string = "EMPLEADO_LIST";
  static readonly EMPLEADO_EDIT: string = "EMPLEADO_EDIT";
  static readonly EMPLEADO_ADD: string = "EMPLEADO_ADD";
  static readonly EMPLEADO_DELETE: string = "EMPLEADO_DELETE";
  
  static readonly EMPLEADO_DOCUMENTO_LIST: string = "EMPLEADO_DOCUMENTO_LIST";
  static readonly EMPLEADO_DOCUMENTO_EDIT: string = "EMPLEADO_DOCUMENTO_EDIT";

  static readonly MOTIVO_INASISTENCIA: string = "MOTIVO_INASISTENCIA";
  static readonly MOTIVO_INASISTENCIA_LIST: string = "MOTIVO_INASISTENCIA_LIST";
  static readonly MOTIVO_INASISTENCIA_EDIT: string = "MOTIVO_INASISTENCIA_EDIT";
  static readonly MOTIVO_INASISTENCIA_ADD: string = "MOTIVO_INASISTENCIA_ADD";
  static readonly MOTIVO_INASISTENCIA_DELETE: string = "MOTIVO_INASISTENCIA_DELETE";

  static readonly GREMIO: string = "GREMIO";
  static readonly GREMIO_LIST: string = "GREMIO_LIST";
  static readonly GREMIO_EDIT: string = "GREMIO_EDIT";
  static readonly GREMIO_ADD: string = "GREMIO_ADD";
  static readonly GREMIO_DELETE: string = "GREMIO_DELETE";

  static readonly ESTADO_CIVIL: string = "ESTADO_CIVIL";
  static readonly ESTADO_CIVIL_LIST: string = "ESTADO_CIVIL_LIST";
  static readonly ESTADO_CIVIL_EDIT: string = "ESTADO_CIVIL_EDIT";
  static readonly ESTADO_CIVIL_ADD: string = "ESTADO_CIVIL_ADD";
  static readonly ESTADO_CIVIL_DELETE: string = "ESTADO_CIVIL_DELETE";

  static readonly RUBRO_CONTABLE: string = "RUBRO_CONTABLE";
  static readonly RUBRO_CONTABLE_LIST: string = "RUBRO_CONTABLE_LIST";
  static readonly RUBRO_CONTABLE_EDIT: string = "RUBRO_CONTABLE_EDIT";
  static readonly RUBRO_CONTABLE_ADD: string = "RUBRO_CONTABLE_ADD";
  static readonly RUBRO_CONTABLE_DELETE: string = "RUBRO_CONTABLE_DELETE";

  static readonly REPORTE_ASISTENCIAS: string = "REPORTE_ASISTENCIAS";
  static readonly PEDIDO_REPORTE_ENTREGAS_PLANIFICADAS: string = "PEDIDO_REPORTE_ENTREGAS_PLANIFICADAS";
  static readonly REPORTE_ESTADO_CUENTAS: string = "REPORTE_ESTADO_CUENTAS";
  static readonly REPORTE_CONSOLIDADO_CAJA: string = "REPORTE_CONSOLIDADO_CAJA";
  static readonly REPORTE_PEDIDO_ITEMS: string = "REPORTE_PEDIDO_ITEMS";
  static readonly REPORTE_CUENTAS_DEUDORAS: string = "REPORTE_CUENTAS_DEUDORAS";
  
  static readonly TIPO_CONTRATO: string = "TIPO_CONTRATO";
  static readonly TIPO_CONTRATO_LIST: string = "TIPO_CONTRATO_LIST";
  static readonly TIPO_CONTRATO_EDIT: string = "TIPO_CONTRATO_EDIT";
  static readonly TIPO_CONTRATO_ADD: string = "TIPO_CONTRATO_ADD";
  static readonly TIPO_CONTRATO_DELETE: string = "TIPO_CONTRATO_DELETE";

  static readonly DASHBOARDS: string = "DASHBOARDS";
  static readonly DASHBOARD_SEGUROS_VENCIMIENTO: string = "DASHBOARD_SEGUROS_VENCIMIENTO";
  static readonly DASHBOARD_PEDIDOS_VENCIMIENTO: string = "DASHBOARD_PEDIDOS_VENCIMIENTO";
  static readonly DASHBOARD_PEDIDOS_ESTADOS: string = "DASHBOARD_PEDIDOS_ESTADOS";
  static readonly DASHBOARD_COMUNIDAD_HOME: string = "DASHBOARD_COMUNIDAD_HOME";
  static readonly DASHBOARD_CAJA_CHICA: string = "DASHBOARD_CAJA_CHICA";
  static readonly DASHBOARD_INCIDENCIAS_VENCIMIENTO: string = "DASHBOARD_INCIDENCIAS_VENCIMIENTO";
  static readonly DASHBOARD_GASTOS_SERVICIO: string = "DASHBOARD_GASTOS_SERVICIO";
  static readonly DASHBOARD_GASTOS_TIPO_GASTO: string = "DASHBOARD_GASTOS_TIPO_GASTO";
  static readonly DASHBOARD_MOVIMIENTOS_TIPO_MOVIMIENTO: string = "DASHBOARD_MOVIMIENTOS_TIPO_MOVIMIENTO";
  static readonly DASHBOARD_GASTOS_RANKING_SERVICIO: string = "DASHBOARD_GASTOS_RANKING_SERVICIO";
  static readonly DASHBOARD_GASTOS_RANKING_TIPO_GASTO: string = "DASHBOARD_GASTOS_RANKING_TIPO_GASTO";
  static readonly DASHBOARD_PEDIDOS_VENCIMIENTO_TIPO_MATERIAL: string = "DASHBOARD_PEDIDOS_VENCIMIENTO_TIPO_MATERIAL";
  static readonly DASHBOARD_EXPENSA_UF: string = "DASHBOARD_EXPENSA_UF";
  static readonly DASHBOARD_MIS_MOVIMIENTOS_PAGOS: string = "DASHBOARD_MIS_MOVIMIENTOS_PAGOS";
  static readonly DASHBOARD_MIS_GASTOS_UF: string = "DASHBOARD_MIS_GASTOS_UF";
  static readonly DASHBOARD_MI_RESUMEN_SALDO: string = "DASHBOARD_MI_RESUMEN_SALDO";
  static readonly DASHBOARD_PUBLICACIONES: string = 'DASHBOARD_PUBLICACIONES';

  static readonly PEDIDO: string = "PEDIDO";
  static readonly PEDIDO_LIST: string = "PEDIDO_LIST";
  static readonly PEDIDO_EDIT: string = "PEDIDO_EDIT";
  static readonly PEDIDO_ADD: string = "PEDIDO_ADD";
  static readonly PEDIDO_DELETE: string = "PEDIDO_DELETE";
  static readonly PEDIDO_ACTIONS: string = "PEDIDO_ACTIONS";
  static readonly PEDIDO_PERMISO_APROBACION: string = "PEDIDO_PERMISO_APROBACION";
  static readonly PEDIDO_PERMISO_PRESTAMO: string = "PEDIDO_PERMISO_PRESTAMO";

  static readonly PEDIDO_MATERIAL = "PEDIDO_MATERIAL";
  static readonly PEDIDO_MATERIAL_ADD = "PEDIDO_MATERIAL_ADD";
  static readonly PEDIDO_MATERIAL_EDIT = "PEDIDO_MATERIAL_EDIT";
  static readonly PEDIDO_MATERIAL_DELETE = "PEDIDO_MATERIAL_DELETE";
  static readonly PEDIDO_MATERIAL_LIST = "PEDIDO_MATERIAL_LIST";

  static readonly PEDIDO_REMITO = "PEDIDO_REMITO";
  static readonly PEDIDO_REMITO_ADD = "PEDIDO_REMITO_ADD";
  static readonly PEDIDO_REMITO_EDIT = "PEDIDO_REMITO_EDIT";
  static readonly PEDIDO_REMITO_DELETE = "PEDIDO_REMITO_DELETE";
  static readonly PEDIDO_REMITO_LIST = "PEDIDO_REMITO_LIST";

  static readonly PEDIDO_PRESUPUESTO: string = "PEDIDO_PRESUPUESTO";
  static readonly PEDIDO_PRESUPUESTO_LIST: string = "PEDIDO_PRESUPUESTO_LIST";
  static readonly PEDIDO_PRESUPUESTO_EDIT: string = "PEDIDO_PRESUPUESTO_EDIT";
  static readonly PEDIDO_PRESUPUESTO_ADD: string = "PEDIDO_PRESUPUESTO_ADD";
  static readonly PEDIDO_PRESUPUESTO_DELETE: string = "PEDIDO_PRESUPUESTO_DELETE";
  static readonly PEDIDO_PRESUPUESTO_SELECT: string = "PEDIDO_PRESUPUESTO_SELECT";

  static readonly PEDIDO_ENVIAR_PENDIENTE_COORDINACION = "PEDIDO_ENVIAR_PENDIENTE_COORDINACION";
  static readonly PEDIDO_ENVIAR_PRESUPUESTAR = "PEDIDO_ENVIAR_PRESUPUESTAR";
  static readonly PEDIDO_ENVIAR_REVISION = "PEDIDO_ENVIAR_REVISION";
  static readonly PEDIDO_ENVIAR_PENDIENTE_ENTREGA = "PEDIDO_ENVIAR_PENDIENTE_ENTREGA";
  static readonly PEDIDO_ENVIAR_ENTREGADO = "PEDIDO_ENVIAR_ENTREGADO";
  static readonly PEDIDO_ENVIAR_FINALIZADO = "PEDIDO_ENVIAR_FINALIZADO";

  static readonly FORMA_PAGO: string = "FORMA_PAGO";
  static readonly FORMA_PAGO_LIST: string = "FORMA_PAGO_LIST";
  static readonly FORMA_PAGO_EDIT: string = "FORMA_PAGO_EDIT";
  static readonly FORMA_PAGO_ADD: string = "FORMA_PAGO_ADD";
  static readonly FORMA_PAGO_DELETE: string = "FORMA_PAGO_DELETE";

  static readonly PROVEEDOR: string = "PROVEEDOR";
  static readonly PROVEEDOR_LIST: string = "PROVEEDOR_LIST";
  static readonly PROVEEDOR_EDIT: string = "PROVEEDOR_EDIT";
  static readonly PROVEEDOR_ADD: string = "PROVEEDOR_ADD";
  static readonly PROVEEDOR_DELETE: string = "PROVEEDOR_DELETE";

  static readonly BANCO: string = "BANCO";
  static readonly BANCO_LIST: string = "BANCO_LIST";
  static readonly BANCO_EDIT: string = "BANCO_EDIT";
  static readonly BANCO_ADD: string = "BANCO_ADD";
  static readonly BANCO_DELETE: string = "BANCO_DELETE";

  static readonly COMPRAS_LIST: string = "COMPRAS_LIST";
  static readonly RECEPCION_PEDIDO: string = "RECEPCION_PEDIDO";
  static readonly RECEPCION_PEDIDO_EDIT: string = "RECEPCION_PEDIDO_EDIT";

  static readonly ACTIVIDAD_PRINCIPAL: string = "ACTIVIDAD_PRINCIPAL";
  static readonly ACTIVIDAD_PRINCIPAL_LIST: string = "ACTIVIDAD_PRINCIPAL_LIST";
  static readonly ACTIVIDAD_PRINCIPAL_EDIT: string = "ACTIVIDAD_PRINCIPAL_EDIT";
  static readonly ACTIVIDAD_PRINCIPAL_ADD: string = "ACTIVIDAD_PRINCIPAL_ADD";
  static readonly ACTIVIDAD_PRINCIPAL_DELETE: string = "ACTIVIDAD_PRINCIPAL_DELETE";

  static readonly ALICUOTA_IVA: string = "ALICUOTA_IVA";
  static readonly ALICUOTA_IVA_LIST: string = "ALICUOTA_IVA_LIST";
  static readonly ALICUOTA_IVA_ADD: string = "ALICUOTA_IVA_ADD";
  static readonly ALICUOTA_IVA_EDIT: string = "ALICUOTA_IVA_EDIT";
  static readonly ALICUOTA_IVA_DELETE: string = "ALICUOTA_IVA_DELETE";

  static readonly MEDIO_PAGO: string = "MEDIO_PAGO";
  static readonly MEDIO_PAGO_LIST: string = "MEDIO_PAGO_LIST";
  static readonly MEDIO_PAGO_EDIT: string = "MEDIO_PAGO_EDIT";
  static readonly MEDIO_PAGO_ADD: string = "MEDIO_PAGO_ADD";
  static readonly MEDIO_PAGO_DELETE: string = "MEDIO_PAGO_DELETE";

  static readonly TIPO_MOVIMIENTO: string = "TIPO_MOVIMIENTO";
  static readonly TIPO_MOVIMIENTO_LIST: string = "TIPO_MOVIMIENTO_LIST";
  static readonly TIPO_MOVIMIENTO_EDIT: string = "TIPO_MOVIMIENTO_EDIT";
  static readonly TIPO_MOVIMIENTO_ADD: string = "TIPO_MOVIMIENTO_ADD";
  static readonly TIPO_MOVIMIENTO_DELETE: string = "TIPO_MOVIMIENTO_DELETE";

  static readonly MOVIMIENTO: string = "MOVIMIENTO";
  static readonly MOVIMIENTO_EDIT: string = "MOVIMIENTO_EDIT";
  static readonly MOVIMIENTO_LIST: string = "MOVIMIENTO_LIST";
  static readonly MOVIMIENTO_PAGO: string = "MOVIMIENTO_PAGO";
  static readonly MOVIMIENTO_DEUDA: string = "MOVIMIENTO_DEUDA";
  static readonly MOVIMIENTO_FINANCIACION: string = "MOVIMIENTO_FINANCIACION";
  static readonly MOVIMIENTO_CANCELACION: string = "MOVIMIENTO_CANCELACION";
  static readonly MOVIMIENTO_CHANGE_STATE: string = "MOVIMIENTO_CHANGE_STATE";
  static readonly MOVIMIENTO_RECURRENTES: string = "MOVIMIENTO_RECURRENTES";
  static readonly MOVIMIENTO_ANALISIS_DOCUMENTO: string = "MOVIMIENTO_ANALISIS_DOCUMENTO";
  static readonly MOVIMIENTO_ANALISIS_DOCUMENTO_MASIVO: string = "MOVIMIENTO_ANALISIS_DOCUMENTO_MASIVO";
  static readonly MIS_MOVIMIENTOS_LIST: string = "MIS_MOVIMIENTOS_LIST";

  static readonly JOBS: string = "JOBS";
  static readonly JOBS_MOVIMIENTO_SEGUNDO_VENCIMIENTO: string = "JOBS_MOVIMIENTO_SEGUNDO_VENCIMIENTO";
}
